<template v-if="cv.personalInfo">
  <div class="container">
    <div v-for="cv in cvs" :key="cv.id" class="cv">
      <div>
        <div class="cv-header">
          <a v-if="cv.locale == 1" style="text-decoration: none;color:black" @click="saveid(cv.id,cv.requestId)" href="/en/expert-info/"><img :src="cv.personalInfo.personalPhoto" /></a>
           <a v-else style="text-decoration: none;color:black" @click="saveid(cv.id,cv.requestId)" href="/expert-info/"><img :src="cv.personalInfo.personalPhoto" /></a>
        </div>
        <div class="user">
          <div class="user-info">
            <h2>
              <a v-if="cv.locale == 1" style="text-decoration: none;color:black; " @click="saveid(cv.id,cv.requestId)" href="/en/expert-info/">{{ cv.personalInfo.fullName }}</a>
              <a v-else style="text-decoration: none;color:black" @click="saveid(cv.id,cv.requestId)" href="/expert-info/">{{ cv.personalInfo.fullName }}</a>
            </h2>
          </div>
        </div>
        <div class="cv-body">
          <template v-if="cv.about" >
             <p>
            {{ cv.about.bio }}
          </p>

          </template>
         
          <!-- <div class="user-info">
            <a
              @click="saveid(cv.id)"
              class="btn btn-danger btn-lg "
              :href="'/testapi/expert-info/'"
              >Read more..</a
            >
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      cvs: {},
    };
  },
  name: "Experts",
  methods: {
    allInfo() {
        let url = localStorage.url;
         if (url=="/en/experts-women/") { 
      axios
        .get("https://api.app.qalat.org/qalat-cvs/1")
        .then(response => {
          if (response.status != 200) {
            console.log(response.status);
          } else {
            this.cvs = response.data;
          }
        })
        .catch();
    }else{
       axios
        .get("https://api.app.qalat.org/qalat-cvs/0")
        .then(response => {
          if (response.status != 200) {
            console.log(response.status);
          } else {
            this.cvs = response.data;
          }
        })
        .catch();
    }
    },
    saveid(id) {
      localStorage.setItem("cv", id);
    }
  },
  mounted() {
    this.allInfo();
  },
   created(){
    var currentUrl = window.location.pathname;
    localStorage.setItem("url", currentUrl);
    
     
  }
 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

.cv {
  background-color: #f8f8f8;
  overflow: hidden;
  width: 32.3333%;
  height: 450px;
  margin: 5px;
  display: inline-block;
}
.btnmore {
  color: #fff;
  background-color: #f23630;
  border-color: #ffffff00;
}
.cv-header img {
  width: 100%;
  height: 400px;
  padding: 0px;
  object-fit: cover;
}
.cv-header {
  padding: 0 !important;
}
.cv-body {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 5px;
  min-height: 250px;
}
.tag {
  background-color: #ccc;
  color: #fff;
  border-radius: 50px;
  font-size: 12px;
  margin: 0;
  padding: 2px 10px;
  text-transform: uppercase;
}
.tag-teal {
  background-color: #92d4e4;
}
.tag-purple {
  background-color: #3d1d94;
}
.tag-pink {
  background-color: #c62bcd;
}
.cv-body h4 {
  margin: 10px 0;
}
.cv-body p {
  font-size: 14px;
  margin: 0 0 0px 0;
  font-weight: 500;
  color: rgb(70, 68, 68);
}
.user {

  display: flex;
  margin-top: auto;
}
.user img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}
.user-info h5 {
  margin: 0;
}
.user-info small {
  color: #888785;
}

</style>
